import {NavController, NavParams} from "ionic-angular";
import {Component} from "@angular/core";
import {apiconfig} from "../../app/api.config";
import {AuthService} from "../../services/AuthService";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'page-kpi',
  templateUrl: 'kpiSheets.html',
})
export class KpiSheetsPage {

  uiloading: boolean = false;
  apiConfig: any = apiconfig;
  urlDashboard : SafeResourceUrl;

  constructor(public navCtrl: NavController,
              public authService: AuthService,
              public navParams: NavParams,
              protected sanitizer: DomSanitizer) {
  }

  ionViewDidLoad() {

    let carId: number = this.navParams.data['cardId'];
    let rolDefinitionName: string = this.navParams.data['rolDefinitionName'];
    let urlDashboard : string = this.navParams.data['urlDashboard'];

    let animaToken: string = this.authService.buildAnimaDashboardToken(carId, rolDefinitionName);

    let url : string = urlDashboard + "&token=" + animaToken;
    console.log(url)

    this.urlDashboard=this.sanitizer.bypassSecurityTrustResourceUrl(url);

    this.uiloading = true;

  }

}



// WEBPACK FOOTER //
// ./src/pages/kpi/kpi.ts